import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from '@src/app/_helpers/jwt.interceptor';
import { ErrorInterceptor } from '@src/app/_helpers/error.interceptor';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { TitleService } from '@src/app/_services/title.service';
import { AuthenticationService } from '@src/app/_services/authentication.service';
import { ErrorModule } from '@src/app/main-layout/errors/error.module';
import { MessageService } from '@src/app/_services/message.service';
import { VersionCheckService } from '@src/app/_services/version-check.service';
import { DataService } from '@src/app/_services/data.service';
import { AutologoutService } from '@src/app/_services/autologout.service';
import { CustomStorageService } from '@src/app/_services/custom-storage.service';
import { EnvironmentService } from '@src/app/_services/environment.service';
import { INITIALIZER_PROVIDER } from '@src/app/_providers/initializer.provider';
import { ROUTES } from '@src/app/app.routes.const';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    imports: [BrowserAnimationsModule, BrowserModule, ErrorModule, RouterModule.forRoot(ROUTES)],
    providers: [
        AuthenticationService,
        AutologoutService,
        CustomStorageService,
        DataService,
        EnvironmentService,
        INITIALIZER_PROVIDER,
        MessageService,
        TitleService,
        VersionCheckService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
